import type { TCheckboxLabelPosition, TCheckboxProps, TCheckboxSize } from './Checkbox.type';

export const CHECKBOX_SIZES: TCheckboxSize[] = ['sm', 'md', 'lg'];
export const CHECKBOX_SIZE: { [key in TCheckboxSize]: key } = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
}

export const CHECKBOX_LABEL_POSITIONS: TCheckboxLabelPosition[] = ['left', 'right'];
export const CHECKBOX_LABEL_POSITION: { [key in TCheckboxLabelPosition]: key } = {
  left: 'left',
  right: 'right'
}

export const CHECKBOX_DEFAULT_PROPS: TCheckboxProps = {
  labelPosition: CHECKBOX_LABEL_POSITION.right,
  size: CHECKBOX_SIZE.md,
}
